var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-loading",staticStyle:{"width":"100%","height":"100vh","background":"#333","position":"absolute","z-index":"10200","top":"0","pointer-events":"auto"}},[_vm._v("\n     \n")])
}
var staticRenderFns = []

export { render, staticRenderFns }